import ValidateForm from "./components/validate-form";

function HomePage(): React.JSX.Element {
  return <ValidateForm />;
}

export default HomePage;
